import {
  BuildOutlined,
  ProjectOutlined,
  UnorderedListOutlined,
  PartitionOutlined,
  CalculatorOutlined,
  FileSearchOutlined,
  PictureOutlined,
  AppstoreOutlined,
  ContainerOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import type { SidebarConfig } from './types';

export const engineeringSidebar: SidebarConfig = {
  module: 'engineering',
  titleKey: 'common:nav.engineering',
  icon: <BuildOutlined />,
  sections: [
    {
      key: 'delivery',
      labelKey: 'engineering:sidebar.sections.delivery',
      items: [
        { key: 'projects', path: '/engineering/projects', labelKey: 'engineering:pages.projects', icon: <ProjectOutlined /> },
        { key: 'wbs', path: '/engineering/wbs', labelKey: 'engineering:pages.wbs', icon: <PartitionOutlined /> },
        { key: 'boq', path: '/engineering/boq', labelKey: 'engineering:pages.boq', icon: <UnorderedListOutlined /> },
      ],
    },
    {
      key: 'planning',
      labelKey: 'engineering:sidebar.sections.planning',
      items: [
        { key: 'estimates', path: '/engineering/estimates', labelKey: 'engineering:pages.estimates', icon: <CalculatorOutlined /> },
        { key: 'material-requests', path: '/engineering/material-requests', labelKey: 'engineering:pages.materialRequests', icon: <ContainerOutlined /> },
      ],
    },
    {
      key: 'documents',
      labelKey: 'engineering:sidebar.sections.documents',
      items: [
        { key: 'drawings', path: '/engineering/drawings', labelKey: 'engineering:pages.drawings', icon: <PictureOutlined /> },
        { key: 'submittals', path: '/engineering/submittals', labelKey: 'engineering:pages.submittals', icon: <FileSearchOutlined /> },
        { key: 'bim', path: '/engineering/bim', labelKey: 'engineering:pages.bim', icon: <AppstoreOutlined /> },
        { key: 'tech-docs', path: '/engineering/tech-docs', labelKey: 'engineering:pages.techDocs', icon: <FileTextOutlined /> },
      ],
    },
  ],
};
